"use client";

import classNames from "classnames";
import DOMPurify from "isomorphic-dompurify";
import Image from "next/image";
import Link from "next/link";
import React from "react";
import styles from "./productCard.module.css";

function ProductCard({
  product,
  round,
  showCategory,
  showBrand,
}: {
  product: {
    name: string;
    images: string[];
    price: number;
    id: string;
    slug: string;
    category_name: string;
    brand: string;
    desc: string;
  };
  round?: boolean;
  showCategory?: boolean;
  showBrand?: boolean;
}) {
  // console.log("PROD: ", product);
  // category_name
  // desc
  // brand

  return (
    <li key={product.id} className={styles.productCard}>
      {/* <Link href={`/product/${DOMPurify.sanitize(product.id)}`}> */}
      <Link href={`/product/${DOMPurify.sanitize(product.slug ?? product.id)}`}>
        <div
          className={classNames(
            styles.productImage,
            round ? styles.noRoundBottom : ""
          )}
        >
          <div className={styles.imageWrapper}>
            <Image
              fill
              sizes="(max-width: 768px) 100vw, 400px"
              src={product.images[0]}
              alt={product.name}
              loading="lazy"
            />
            <div className={styles.tagsDiv}>
              {showCategory && (
                <span className={styles.categoryName}>
                  {product.category_name}
                </span>
              )}
              {(product.category_name === "Complete Solution" ||
                product.category_name === "Solar All-In-One Box") && (
                <span className={styles.loanAvailable}>Loan Available</span>
              )}
            </div>
          </div>
        </div>

        <div
          className={classNames(styles.deetDiv, round ? styles.leftPad : "")}
        >
          {showBrand && (
            <span className={styles.brandName}>{product.brand}</span>
          )}
          <h3>{product.name}</h3>
          <span className={styles.desc}>{product.desc}</span>
          <p>₦{product.price.toLocaleString()}</p>
        </div>
      </Link>
    </li>
  );
}

export default ProductCard;
